import React, {useState} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {InfoField} from '../../common/InfoField'
import classes from './styles.module.scss'
import {ContactInfo} from '../../../api/model/ContactInfo'
import {locationData} from './locationData'
import {CustomButton} from '../../common/CustomButton'
import Modal from '../../../../../uiKit/Modal'
import {updateLabConsentFormLink} from '../../../api/contactInfoApi'

export const preparePhoneNumber = (phone: string): string => {
  return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6, 10)}`
}

interface GeneralInfoSectionProps {
    contactInfo: ContactInfo
    match: any
}

const GeneralInfoSection: React.FC<GeneralInfoSectionProps> = ({contactInfo, match}) => {

  const [isLabConsentModalOpen, setIsLabConsentModalOpen] = useState<boolean>(false)
  const [labConsentLinkValue, setLabConsentLinkValue] = useState<string>(contactInfo.labConsentFormLink || '')
  const [isSavingLabConsentLink, setIsSavingLabConsentLink] = useState<boolean>(false)

  const {
    firstAndLastName,
    username,
    email,
    phone,
    recruitmentLocation,
    activationLink,
    labConsentFormLink
  } = contactInfo

  const isLabConsentLinkSet = !!labConsentFormLink

  const handleOpenLabConsentModal = () => {
    if (isLabConsentLinkSet) {
      return
    }
    setLabConsentLinkValue(labConsentFormLink || '')
    setIsLabConsentModalOpen(true)
  }

  const handleCloseLabConsentModal = () => {
    setIsLabConsentModalOpen(false)
  }

  const handleSaveLabConsentLink = async () => {
    if (!labConsentLinkValue || isSavingLabConsentLink) {
      return
    }
    setIsSavingLabConsentLink(true)
    try {
      await updateLabConsentFormLink(labConsentLinkValue, match.params.botId, match.params.contactId)
      setIsLabConsentModalOpen(false)
    } finally {
      setIsSavingLabConsentLink(false)
    }
  }

  return (
    <>
      <Modal
        classes={{paper: classes.labConsentModalPaper}}
        open={isLabConsentModalOpen}
        onClose={handleCloseLabConsentModal}
      >
        <div className={classes.labConsentModalContent}>
          <div className={classes.labConsentModalTitle}>Lab Consent Form link</div>
          <input
            className={classes.labConsentInput}
            value={labConsentLinkValue}
            onChange={e => setLabConsentLinkValue(e.target.value)}
            placeholder='Paste Lab Consent Form link'
          />
          <div className={classes.labConsentButtons}>
            <CustomButton
              text='Cancel'
              disabled={isSavingLabConsentLink}
              fulled={false}
              onBtnClick={handleCloseLabConsentModal}
            />
            <CustomButton
              text='Save link'
              disabled={!labConsentLinkValue || isSavingLabConsentLink}
              fulled={false}
              onBtnClick={handleSaveLabConsentLink}
            />
          </div>
        </div>
      </Modal>
      <div className={classes.userName}>
        {firstAndLastName}
      </div>
      <InfoField
        title={'User name'}
        value={username}
      />
      <InfoField
        title={'Email address'}
        value={email}
      />
      <InfoField
        title={'Phone number'}
        value={phone ? preparePhoneNumber(phone) : 'NONE'}
      />
      <InfoField
        title={'Recruitment location'}
        value={locationData[recruitmentLocation]}
        styles={{ marginTop: 20 }}
      />
      <InfoField
        title={'Activation link'}
        value={activationLink ? activationLink : 'NONE'}
        styles={{ marginTop: 20 }}
        link={!!activationLink }
      />
      <InfoField
        title={'Lab Consent Form link'}
        value={labConsentFormLink ? labConsentFormLink : 'NONE'}
        styles={{ marginTop: 20 }}
        link={!!labConsentFormLink}
      />
      <div className={classes.labConsentButtonWrapper}>
        <CustomButton
          text='Add Lab Consent Form link'
          disabled={isLabConsentLinkSet}
          fulled={false}
          onBtnClick={handleOpenLabConsentModal}
        />
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  contactInfo: state.contactInfo
})

export default withRouter(connect(mapStateToProps)(GeneralInfoSection))
